// SubscriptionPage2.jsx
import React from "react";
import classes from "./SubscriptionPage3.module.css";
import { motion } from "framer-motion";

const SubscriptionPage3 = () => {
  return (
    <main className={classes.main}>
      <motion.div
        className={classes.container}
        initial={{
          backgroundImage:
            "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
        }}
        animate={{
          backgroundImage: [
            "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
            "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
            "radial-gradient(820% 320% at 50% 25%, #000, #f5b342)",
            "radial-gradient(820% 320% at 50% 25%, #000, #8e44ad)",
          ],
        }}
        transition={{
          duration: 7,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "mirror",
        }}
      >
        {/* background glow blobs */}
        <div className={classes.glowLayer} />

        {/* Shining / neon layers (rings + trails + sparks) */}
        <div className={classes.neonWrap} aria-hidden="true">
          {/* Rings */}
          <span className={`${classes.ring} ${classes.ring1}`} />
          <span className={`${classes.ring} ${classes.ring2}`} />
          <span className={`${classes.ring} ${classes.ring3}`} />

          {/* SVG neon trails */}
          <svg
            className={classes.neonLines}
            viewBox="0 0 1200 800"
            preserveAspectRatio="none"
          >
            <defs>
              <filter id="neonGlow" x="-40%" y="-40%" width="180%" height="180%">
                <feGaussianBlur stdDeviation="7" result="blur1" />
                <feMerge>
                  <feMergeNode in="blur1" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>

              <filter id="softGlow" x="-30%" y="-30%" width="160%" height="160%">
                <feGaussianBlur stdDeviation="3" result="b" />
                <feMerge>
                  <feMergeNode in="b" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>

              <linearGradient id="trail" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="rgba(255,0,60,0)" />
                <stop offset="40%" stopColor="rgba(255,0,60,.95)" />
                <stop offset="100%" stopColor="rgba(255,0,60,0)" />
              </linearGradient>

              <linearGradient id="trailSoft" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="rgba(255,0,60,0)" />
                <stop offset="45%" stopColor="rgba(255,0,60,.55)" />
                <stop offset="100%" stopColor="rgba(255,0,60,0)" />
              </linearGradient>
            </defs>

            {/* BIG soft trail */}
            <path
              className={classes.neonFat}
              d="M-50,520 C220,280 480,720 760,480 C950,315 1060,330 1250,240"
              stroke="url(#trailSoft)"
              filter="url(#neonGlow)"
            />
            {/* crisp trail */}
            <path
              className={classes.neonThin}
              d="M-50,520 C220,280 480,720 760,480 C950,315 1060,330 1250,240"
              stroke="url(#trail)"
              filter="url(#softGlow)"
            />

            {/* second trail */}
            <path
              className={classes.neonFat2}
              d="M-20,720 C230,610 380,760 560,690 C760,610 880,520 1020,560 C1120,590 1170,650 1250,720"
              stroke="url(#trailSoft)"
              filter="url(#neonGlow)"
            />
            <path
              className={classes.neonThin2}
              d="M-20,720 C230,610 380,760 560,690 C760,610 880,520 1020,560 C1120,590 1170,650 1250,720"
              stroke="url(#trail)"
              filter="url(#softGlow)"
            />

            {/* sparks */}
            <g className={classes.sparks} filter="url(#softGlow)">
              <circle cx="260" cy="380" r="2.2" fill="rgba(255,80,80,0.9)" />
              <circle cx="520" cy="520" r="1.7" fill="rgba(255,80,80,0.7)" />
              <circle cx="810" cy="460" r="2.4" fill="rgba(255,120,120,0.75)" />
              <circle cx="980" cy="320" r="2.0" fill="rgba(255,80,80,0.9)" />
              <circle cx="1040" cy="560" r="1.6" fill="rgba(255,60,60,0.6)" />
            </g>
          </svg>
        </div>

        <section className={classes.shell}>
          {/* TOP HEADER */}
          <header className={classes.topBar}>
            <div className={classes.brand}>
              <div>
                <img
                  src="/images/logo2.png"
                  alt="uv gaming"
                  className={classes.uv_logo}
                />
                <div className={classes.brandSub}>Powered by Vodafone</div>
              </div>
            </div>

            <div className={classes.topActions}>
              <button className={classes.btnGhost}>Entrar</button>
              <button className={classes.btnPrimary}>Subscrever</button>
            </div>
          </header>

          {/* HERO */}
          <section className={classes.hero}>
            <div className={classes.heroLeft}>
              <h1 className={classes.heroTitle}>
                Jogos Ilimitados <br />
                <span>no Teu Telemóvel</span>
              </h1>

              <div className={classes.pricePill}>
                A partir de <b>3MT</b> / Dia
              </div>

              <div className={classes.heroChips}>
                <div className={classes.chip}>📱 HTML5 + Android</div>
                <div className={classes.chip}>💳 Paga com Saldo ou M-Pesa</div>
              </div>
            </div>

            <div className={classes.heroRight}>
              <img
                src="/images/hero-image2.png"
                alt="Hero"
                className={classes.heroImage}
              />
            </div>
          </section>

          {/* PLANS + HOW */}
          <section className={classes.midGrid}>
            <div className={classes.cardSection}>
              <div className={classes.sectionTitle}>Escolhe o Teu Plano</div>

              <div className={classes.planGrid}>
                <div className={classes.planCard}>
                  <div className={classes.planName}>Diário</div>
                  <div className={classes.planPrice}>
                    <span>3</span>MT
                  </div>
                  <div className={classes.planFeature}>🎮 Acesso 24H</div>
                  <button className={classes.planBtn}>Subscrever</button>
                </div>

                <div className={`${classes.planCard} ${classes.popular}`}>
                  <div className={classes.badge}>Mais Popular</div>
                  <div className={classes.planName}>Semanal</div>
                  <div className={classes.planPrice}>
                    <span>20</span>MT
                  </div>
                  <div className={classes.planFeature}>🗓️ 7 Dias de Jogos</div>
                  <button className={classes.planBtn}>Subscrever</button>
                </div>

                <div className={classes.planCard}>
                  <div className={classes.badgeAlt}>Melhor Valor</div>
                  <div className={classes.planName}>Mensal</div>
                  <div className={classes.planPrice}>
                    <span>50</span>MT
                  </div>
                  <div className={classes.planFeature}>📅 30 Dias de Jogos</div>
                  <button className={classes.planBtn}>Subscrever</button>
                </div>
              </div>
            </div>

            <aside className={classes.howCard}>
              <div className={classes.howTitle}>Como Funciona?</div>

              <div className={classes.steps}>
                <div className={classes.step}>
                  <div className={classes.stepNum}>1</div>
                  <div className={classes.stepText}>Escolhe o Plano</div>
                </div>
                <div className={classes.step}>
                  <div className={classes.stepNum}>2</div>
                  <div className={classes.stepText}>Paga (M-Pesa/Saldo)</div>
                </div>
                <div className={classes.step}>
                  <div className={classes.stepNum}>3</div>
                  <div className={classes.stepText}>Começa a Jogar!</div>
                </div>
              </div>

              <button className={classes.activateBtn}>
                Ativar Agora <span className={classes.arrow}>➜</span>
              </button>
            </aside>
          </section>

          {/* PAYMENT + APP */}
          <section className={classes.bottomGrid}>
            <div className={classes.paymentCard}>
              <div className={classes.cardTitle}>
                <span className={classes.iconDot} /> Pagamento Fácil
              </div>

              <div className={classes.logoGrid}>
                <div className={classes.logo}>Vodafone</div>
                <div className={classes.logo}>M-Pesa</div>
                <div className={classes.logo}>VISA</div>
                <div className={classes.logo}>Mastercard</div>
              </div>

              <div className={classes.safeText}>🔒 Seguro e Instantâneo</div>
            </div>

            <div className={classes.appCard}>
              <div className={classes.appLeft}>
                <div className={classes.cardTitle}>
                  <span className={classes.androidIcon} /> App Android
                </div>

                <button className={classes.downloadBtn}>Download Now</button>

                <div className={classes.ratingRow}>
                  <div className={classes.ratingValue}>4.8</div>
                  <div className={classes.stars}>★★★★★</div>
                </div>
              </div>

              <div className={classes.phoneMock}>
                <span>Phone</span>
              </div>
            </div>
          </section>

          {/* FOOT */}
          <footer className={classes.footerChips}>
            <div className={classes.footChip}>💬 Suporte 24/7</div>
            <div className={classes.footChip}>⛔ Cancela Quando Quiseres</div>
          </footer>
        </section>
      </motion.div>
    </main>
  );
};

export default SubscriptionPage3;